import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {PageAccessStorageService} from '../../store/page-access-storage.service';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {PageAccessInfo} from '../../models/page-access-info';


@Injectable({
  providedIn: 'root'
})
export class PageAccessAdminGuardService implements CanActivate {
  constructor(private router: Router,
              private pageAccessStorageService: PageAccessStorageService) {
  }

  canActivate(): Observable<boolean> {
    if (this.pageAccessStorageService.pageAccessInfo &&
        this.pageAccessStorageService.pageAccessInfo.isAuthorized &&
        this.pageAccessStorageService.pageAccessInfo.oktaInfo.isUserAdmin) {
      return of(true);
    }

    return this.pageAccessStorageService.onTogglePageAccessInfo.pipe(
      map((pageAccessInfo: PageAccessInfo): boolean => {

        if (pageAccessInfo && pageAccessInfo.isAuthorized && this.pageAccessStorageService.pageAccessInfo.oktaInfo.isUserAdmin) {
          return true;
        }

        this.router.navigate(['/']);
        return false;
      })
    );
  }
}
